export default {
  title: 'Metti in pausa la disponibilità',
  description: 'Tutto esaurito?',
  pause_availabilities: {
    pause_until_end_of_day: 'Mettere in pausa le prenotazioni fino alla fine della giornata?',
    pause_specific_time: 'Metti in pausa le prenotazioni per un giorno e/o orario diverso',
  },
  pause_reservations_today: 'Metti in pausa le prenotazioni oggi',
  pause_reservations_another_day: 'Metti in pausa le prenotazioni per un altro giorno',
  paused_availabilities_form: {
    date_time: {
      label: "Seleziona una data e un'ora",
    },
    reason: {
      label: 'Aggiungi un motivo (opzionale)',
      placeholder: 'Inserisci descrizione...',
    },
  },
  buttons: {
    save: 'Salva',
  },
  error_messages: {
    creation_failed: 'Creazione eccezione fallita',
  },
};
